// extracted by mini-css-extract-plugin
export default {"alternate":"dfHXz0WIjzno6CeyXN5U"};